import React, { useState } from 'react';
import { mutStore } from './stepcommon';
import { BOND_FIELDS, bondVal, fmtComma, onlyDigits } from './bondcalc';
import BondDocModal from './BondDocModal';
import type { Project, CoCard, Collect } from './types';

interface Props {
  p: Project;
  co: CoCard;
  collect: Collect;
  onPatch: (patch: Partial<Project>) => void;
  toast: (m: string) => void;
}

type ModalState = { slot: 'biz' | 'fin' | 'reg'; fieldKey: string; fieldLabel: string; fieldKind: 'text' | 'num' | 'date'; split?: boolean };

export default function BondForm({ p, co, collect, onPatch }: Props) {
  const [modal, setModal] = useState<ModalState | null>(null);
  const set = (key: string, val: string) =>
    onPatch(mutStore(p, 's8', (st) => { st.txt = st.txt || {}; st.txt[co.id + '_b_' + key] = val; }));

  const docLabel = (slot: 'biz' | 'fin' | 'reg'): string =>
    slot === 'fin' ? '📄 재무제표' : slot === 'reg' ? '📄 등기부등본' : '📄 사업자등록증';

  return (
    <div style={{ marginTop: 10, borderTop: '1px dashed #d6d9e0', paddingTop: 8 }}>
      <div className="codoc-h" style={{ marginBottom: 6 }}><span>📑 전환사채 발행정보 · 문서 자동생성용</span></div>
      {BOND_FIELDS.map((f) => {
        const v = bondVal(p, co, f.key);
        const isNum = f.kind === 'num';
        const isCapital = f.key === 'capital';
        return (
          <div key={f.key} style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 5 }}>
            <label style={{ flex: '0 0 40%', fontSize: 12, color: '#5a6175', lineHeight: 1.25 }}>{f.label}</label>
            <input
              className="cotext"
              style={{ flex: 1, minWidth: 0, ...(isCapital ? { background: '#f3f4f8', cursor: 'pointer' } : {}) }}
              type={f.kind === 'date' ? 'date' : 'text'}
              inputMode={isNum ? 'numeric' : undefined}
              value={isNum ? fmtComma(v) : v}
              onChange={(e) => set(f.key, isNum ? onlyDigits(e.target.value) : e.target.value)}
              placeholder={isCapital ? '재무제표 버튼에서 자본금·준비금 입력' : (f.hint || '')}
              readOnly={isCapital}
              title={isCapital ? '오른쪽 재무제표 버튼을 눌러 자본금·준비금을 입력하면 합산됩니다' : undefined}
              onClick={isCapital ? () => setModal({ slot: 'fin', fieldKey: 'capital', fieldLabel: f.label, fieldKind: f.kind, split: true }) : undefined}
            />
            {f.openDoc ? (
              <button
                className="upbtn sm"
                style={{ flex: '0 0 auto' }}
                onClick={() => setModal({ slot: f.openDoc as 'biz' | 'fin' | 'reg', fieldKey: f.key, fieldLabel: f.label, fieldKind: f.kind, split: isCapital })}
              >{docLabel(f.openDoc as 'biz' | 'fin' | 'reg')}</button>
            ) : null}
          </div>
        );
      })}
      {modal ? (
        <BondDocModal
          p={p}
          co={co}
          collect={collect}
          slot={modal.slot}
          fieldKey={modal.fieldKey}
          fieldLabel={modal.fieldLabel}
          fieldKind={modal.fieldKind}
          split={modal.split}
          onPatch={onPatch}
          onClose={() => setModal(null)}
        />
      ) : null}
    </div>
  );
}
